import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ProductModel } from '../../../../core/models/product.model'
import { TagModule } from 'primeng/tag'

@Component({
  selector: 'app-product-tag',
  standalone: true,
  imports: [TagModule],
  templateUrl: './product-tag.component.html',
  styleUrl: './product-tag.component.scss',
})
export class ProductTagComponent {
  @Input({ required: true }) product: ProductModel | null = null
  @Input() isSelected = false
  @Output() onSelect = new EventEmitter<ProductModel | null>()
  @Output() onUnselect = new EventEmitter<ProductModel | null>()

  toggleSelect() {
    if (this.isSelected) {
      this.onUnselect.emit(this.product)
    } else {
      this.onSelect.emit(this.product)
    }
    this.isSelected = !this.isSelected
  }
}
